import React from 'react';
import { Link, NavLink } from 'react-router-dom';

function PrivacyText({ className }) {
  return (
    <span className={`primary-text-regular normal-case text-t-gray my-3 ${className}`}>
      By signing up, you agree to our
      <Link
        className="medium-black focus:outline-none hover:text-gray-500 normal-case px-1 text-xs"
        to="/terms-of-services">
        Terms of Service
      </Link>
      and acknowledge that you have read our
      <Link
        to="/privacy-policy"
        className="medium-black focus:outline-none hover:text-gray-500 normal-case px-1 text-xs">
        Privacy Policy
      </Link>
      to learn how we collect, use, and share your data.
    </span>
  );
}

export default PrivacyText;
